import React from 'react'
import { Link } from 'react-router-dom'

function BadgeCard({ title, createdAt, imgLink, issueBadge,isAllBadges, label, badge, onClick }) {
  console.log()
  return (
    <div className='badge-card-wrapper mb-3'>
      {isAllBadges && (
        <Link
          to={{
            pathname: '/issuance-history',
            state: {
              badge,
            },
          }}>
          <div className='info-icon'>
            <i className='fas fa-info-circle'></i>
          </div>
        </Link>
      )}
      <div className='badge-card' onClick={onClick ? onClick : () => {}}>
        <img src={`${process.env.REACT_APP_API_URI}${imgLink}`} alt='' />
        <div className='badge-meta-wrapper '>
          <div className=' badge-title px-0'>{title}</div>
          <div className='mt-2 px-0'>
            <span className='badge-meta me-3'>
              {label}: <span className='fw-bold'>{createdAt}</span>
            </span>
            {issueBadge && (
              <span className='text-primary badge-meta'>
                <Link
                  to={{
                    pathname: '/issue',
                    state: {
                      badgeName: title.split('-')[0].trim() + '-' + title.split('-')[1].trim(),
                    },
                  }}>
                  Issue Badge
                </Link>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BadgeCard
